import './App.css';
import { Box } from '@mui/material';
import Login from './components/Login';
import { useDispatch, useSelector } from 'react-redux';
import { hideAlert, logOut, updateAuthLoaded, updateLoginDetails } from './redux/Actions';
import { focusElemnt, initializeInactivityTimer } from './utils/helpers';
import AlertModal from './common/AlertModal';
import { useEffect } from 'react';
import { callGolbleData } from './globleTime';
import LoaderScreen from './common/LoaderScreen';
import { publicRoutes, routeList } from './utils/Routes';
import { useLocation, useRoutes } from 'react-router-dom';

function App() {
  const store = useSelector((store) => store);
  const { user } = store;
  const { showAlert, userDetails, authLoaded } = user;
  const dispatch = useDispatch();
  let element = useRoutes(routeList)
  let defRouteElement = useRoutes(publicRoutes)
  const location = useLocation()
  const handleLogout = () => {
    dispatch(logOut())
  }
  useEffect(() => {
    const viewport = document.querySelector("meta[name=viewport]");

    const updateViewport = () => {
      const isMobile = window.innerWidth <= 1000;

      if (isMobile) {
        viewport.setAttribute(
          "content",
          "width=device-width, initial-scale=0.8"
        );
      } else {
        viewport.setAttribute(
          "content",
          "width=device-width, initial-scale=1"
        );
      }
    };

    updateViewport();
    window.addEventListener("resize", updateViewport);

    return () => window.removeEventListener("resize", updateViewport);
  }, []);

  useEffect(() => {
    const blockedAgents = new Set([32092, 18686, 17325]);

    // Only run for blocked agents
    if (!blockedAgents.has(Number(userDetails?.AgentID))) {
      return;
    }

    const handleKeyDown = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey &&
          e.shiftKey &&
          ["I", "J", "C"].includes(e.key.toUpperCase())) ||
        (e.ctrlKey && e.key.toUpperCase() === "U")
      ) {
        e.preventDefault();
      }
    };

    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [userDetails]);

  useEffect(() => {
    const cleanup = initializeInactivityTimer(
      handleLogout,
      240
    );
    return cleanup;
  }, [user?.userDetails]);
  useEffect(() => {
    const sessionUser = sessionStorage.getItem('userDetails');
    if (sessionUser) {
      dispatch(updateLoginDetails(JSON.parse(sessionUser)));
      dispatch(updateAuthLoaded(true));

    } else {
      dispatch(updateAuthLoaded(true));
    }
  }, [dispatch]);

  useEffect(() => {
    if (sessionStorage?.getItem('timeConfig') !== null) {
      callGolbleData()
    }
  }, [sessionStorage?.getItem('timeConfig')])

  const handleAlertClose = (open = false, nextId = '') => {
    dispatch(hideAlert());
    if (nextId !== '') {
      setTimeout(() => {
        focusElemnt(nextId)
      }, 50)
    }
  };
  if (!authLoaded) {
    return <LoaderScreen />; // or null
  }
  let checkUrl = location?.pathname === "/terms_of_use" || location?.pathname === "/privacy_policy"
  return (
    <Box>
      {user.loadingScreen && <LoaderScreen />}

      {(sessionStorage?.getItem('userDetails') === null || Object.keys(userDetails || {}).length === 0) && !checkUrl ?
        <>
          <Login />
        </>
        :
        <>
          {element}
        </>
      }
      {defRouteElement}
      {
        showAlert.open &&
        <AlertModal
          open={showAlert.open}
          message={showAlert.message}
          severity={showAlert.severity}
          btnText={showAlert.btnText}
          onClose={handleAlertClose}
          nextId={showAlert?.nextId || ""}
        />
      }
    </Box>
  );
}

export default App;
